var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.671,
    height: 16.238,
    viewBox: "0 0 20.671 16.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.934,16.235c-1.456,0-2.911.002-4.367,0-1.701-.003-3.108-1.132-3.476-2.79-.127-.571-.094-1.152-.064-1.728.023-.451.455-.791.896-.77.47.022.838.387.853.857.009.289.001.578.003.867.005,1.03.758,1.796,1.786,1.798,2.922.005,10.637.005,13.559,0,1.02-.002,1.774-.768,1.781-1.788.002-.279-.002-.557.001-.836.006-.508.401-.906.89-.899.489.006.874.396.872.9-.003.561.037,1.124-.091,1.68-.35,1.527-1.76,2.69-3.327,2.705-1.507.014-7.808.003-9.315.003h0Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.082,10.641H4.517c-.54,0-.977-.437-.977-.977s.437-.977.977-.977h11.565c.54,0,.977.437.977.977s-.437.977-.977.977Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.082,6.276H4.517c-.54,0-.977-.437-.977-.977s.437-.977.977-.977h11.565c.54,0,.977.437.977.977s-.437.977-.977.977Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.082,1.954H4.517c-.54,0-.977-.437-.977-.977s.437-.977.977-.977h11.565c.54,0,.977.437.977.977s-.437.977-.977.977Z",
    fill: "#bababa"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllQueries);
export default __webpack_public_path__ + "static/media/AllQueries.9e24d4a2.svg";
export { ForwardRef as ReactComponent };